import React, { useEffect, useState } from 'react';
import { getAnalyticsConsent, setAnalyticsConsent, trackPageView } from '../services/analytics';

const AnalyticsConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => setVisible(getAnalyticsConsent() === null), []);

  if (!visible) return null;

  const choose = (consent: 'granted' | 'denied') => {
    setAnalyticsConsent(consent);
    setVisible(false);
    if (consent === 'granted') trackPageView(window.location.pathname);
  };

  return (
    <aside role="dialog" aria-label="Analytics privacy choice" style={bannerStyle}>
      <div style={{ flex: 1 }}>
        <strong>Privacy choice</strong>
        <div style={{ marginTop: 4, fontSize: 13, lineHeight: 1.45 }}>
          We use optional, privacy-limited analytics to count visits and actions such as calls and
          completed forms. We never send form contents, contact details, search terms, review text,
          facility names, or listing IDs to Google. <a href="/privacy" style={{ color: '#fff' }}>Learn more</a>.
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button onClick={() => choose('denied')} style={secondaryButton}>Decline</button>
        <button onClick={() => choose('granted')} style={primaryButton}>Allow analytics</button>
      </div>
    </aside>
  );
};

const bannerStyle: React.CSSProperties = {
  position: 'fixed', left: 16, right: 16, bottom: 16, zIndex: 20000,
  maxWidth: 920, margin: '0 auto', padding: 18, borderRadius: 12,
  background: '#111426', color: '#fff', boxShadow: '0 8px 32px rgba(0,0,0,.3)',
  display: 'flex', gap: 18, alignItems: 'center', flexWrap: 'wrap',
};
const primaryButton: React.CSSProperties = {
  border: 0, borderRadius: 8, padding: '10px 14px', background: '#f5a623',
  color: '#111426', fontWeight: 700, cursor: 'pointer',
};
const secondaryButton: React.CSSProperties = {
  ...primaryButton, background: 'transparent', color: '#fff', border: '1px solid #9ca3af',
};

export default AnalyticsConsent;

